import stringifyQueryObjectUtil from 'utils/object/stringify-query'

export default function getPathWithQueryLocationUtil (path, queryParams) {
  // const debugProps = { path, queryParams }
  // logUtil('getPathWithQueryLocationUtil').debug('[start] debugProps=', debugProps)
  const queryString = stringifyQueryObjectUtil(queryParams)
  // logUtil('getPathWithQueryLocationUtil').debug('[start] queryString=', queryString)
  if (!queryString) {
    return path
  }
  return `${path}?${stringifyQueryObjectUtil(queryParams)}`
}
